export const getUserLanguageCode = (activeLang: string) => {
	return activeLang.substring(0, 2);
};

export const getContextLanguageCode = (activeLang: string) => {
	return activeLang.substring(3);
};
